import { PERSON_ROUTES } from 'shared/consts/routes/person';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddPersonMenuButtonLink() {
  return (
    <MenuAddButton
      label="Добавить клиента"
      path={PERSON_ROUTES.ADD_PERSON}
      requiredRights={[
        {
          controller: 'Person',
          right: 'Write',
        },
      ]}
    />
  );
}
